import { createFileRoute } from '@tanstack/react-router';
import { ChargeItemsPage } from '../../features/catalogue';

export const Route = createFileRoute('/portal/catalogue/charge-items')({ component: ChargeItemsPage });
